import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    addRecord,
    addRecordSuccess,
    addRecordFailure
} from './payment.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';

@Injectable()
export class PaymentsRecordEffects {

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                const url = 'workflow-payment?step='+data.step+"&signature="+data.signature;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        const data = response.data;
                        if(data.url){
                            window.location.assign(data.url);
                            return fetchSingleRecordSuccess({singleData: null});
                        }
                        else if(data.completed == true){
                            this.routeService.triggerRoute(null, "/payment/completed");
                            return fetchSingleRecordSuccess({singleData: null});
                        }
                        else{
                            return fetchSingleRecordSuccess({singleData: data});
                        }

                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    addData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addRecord),
            exhaustMap((data: any) => {
                const url = data.linkUrl;
                return this.crudServerService.addData(url, data.newData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        
                        if(response.data.completed == true){
                            this.routeService.triggerRoute(null, "/payment/completed");
                        }else if(response.data.url){
                            window.location.assign(response.data.url);
                        }
                        
                        return addRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => addRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>
    ) { }

}